;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"prciDT73hkSXp13z4dPQr"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';
import { envConfig } from '@/config/env';

Sentry.init({
  dsn: envConfig.sentry.dsn,
  enabled: envConfig.isProduction,
  profilesSampleRate: 0.2,
  tracesSampleRate: 0.5,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 0.5,
  integrations: [
    Sentry.replayIntegration({
      blockAllMedia: true,
    }),
  ],
});
